export class CikeUtils {
  /**week转中文*/
  static weekNumToZH_CN(week: number) {
    switch (week) {
      case 0:
        return '日';
      case 1:
        return '一';
      case 2:
        return '二';
      case 3:
        return '三';
      case 4:
        return '四';
      case 5:
        return '五';
      case 6:
        return '六';
    }
  };

  /**week转英文*/
  static weekNumToUA_EN(week: number) {
    switch (week) {
      case 0:
        return 'SUN';
      case 1:
        return 'MON';
      case 2:
        return 'TUE';
      case 3:
        return 'WED';
      case 4:
        return 'THU';
      case 5:
        return 'FRI';
      case 6:
        return 'SAT';
    }
  };

  /**颜色RGBA转换*/
  static colorRGBA(color: string, a: number = 1) {//将16进制颜色转换成rgb
    color = color?.substring(1) || '#960208';
    color = color?.toLowerCase() || '#960208';
    let b = new Array();
    for (let x = 0; x < 3; x++) {
      b[0] = color.substr(x * 2, 2);
      b[3] = '0123456789abcdef';
      b[1] = b[0].substr(0, 1);
      b[2] = b[0].substr(1, 1);
      b[20 + x] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
    }
    return `rgba(${b[20]},${b[21]},${b[22]},${a})`;
  };

  /**HEX加颜色加深*/
  static colorRGB2Hex(color: string, level: number) {
    let rgb = this.colorRGBA(color, 1);
    /(\d+),(\d+),(\d+)/.test(rgb);
    let r = Math.floor(+RegExp.$1 * (1 - level));
    let g = Math.floor(+RegExp.$2 * (1 - level));
    let b = Math.floor(+RegExp.$3 * (1 - level));
    let hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return hex;
  };

  /**判断非空*/
  static isNull(value: any) {
    if (/String/.test(Object.prototype.toString.call(value))) {
      //字符串类型,判断''和' '
      return +value <= 0 || value == '' || value == ' ' || value == 'null' || value == 'undefined' || value == '[]';
    }
    if (/Number/.test(Object.prototype.toString.call(value))) {
      //字符串类型,判断''和' '
      return +value <= 0;
    }

    if (/Null/.test(Object.prototype.toString.call(value))) {
      return true;
    }

    if (/Undefined/.test(Object.prototype.toString.call(value))) {
      return true;
    }

    if (/Array/.test(Object.prototype.toString.call(value))) {
      //数组类型,判断[]

      return value.length == 0;
    }
    return false;
  }

  static isString(value: any) {
    return /String/.test(Object.prototype.toString.call(value));
  }

  static isNumber(value: any) {
    if (isNaN(value)) {
      return false;
    }
    return /Number/.test(Object.prototype.toString.call(value));
  }

  /**判断是否为对象*/
  static isObj(value: any) {
    const type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
  }

  static isArray(value: any) {
    return /Array/.test(Object.prototype.toString.call(value));
  }

}
